'use client';

import * as Fathom from 'fathom-client';
import { AllFathomEventNames } from '@/lib/fathom-events';

export const useFathomEvent = (eventName: AllFathomEventNames) => {
  const trackEvent = () => {
    if (typeof window !== 'undefined' && process.env.NODE_ENV === 'production') {
      Fathom.trackEvent(eventName);
    }
  };

  return trackEvent;
};
